module.exports = __webpack_public_path__ + "023b75b96409f72a6a3015db472b3b20.svg";